import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://vote-scrap.vercel.app' 
});

export default instance;
